import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {LEGACY_FONT_PROXIMA_13} from 'styles/FontConstants';
import {GRAY_DARK, GRAY_DARKER, ORANGE, ORANGE_LIGHTER} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface WarningBannerProps {
  message: ReactNode;
  collapsed?: boolean;
  onToggleCollapsed?: () => void;
}

/**
 * @deprecated Please use client/ui-library/banners/InlineBanner instead
 */
function WarningBanner({message, collapsed, onToggleCollapsed}: WarningBannerProps): JSX.Element {
  return (
    <div className={css(styles.banner)}>
      <div className={css(styles.warningContainer)}>
        <BenchlingIcon icon="warning" className={css(styles.icon)} color={ORANGE} />
      </div>
      <div className={css(styles.messageContainer)}>
        <span className={css(styles.message)}>{message}</span>
      </div>
      {collapsed !== undefined && (
        <div className={css(styles.warningContainer)}>
          <BenchlingIcon
            icon={collapsed ? 'arrow-down' : 'arrow-up'}
            className={css(styles.icon, styles.button)}
            color={GRAY_DARK}
            onClick={onToggleCollapsed}
          />
        </div>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  banner: {
    backgroundColor: ORANGE_LIGHTER,
    display: 'flex',
    alignItems: 'center',
  },
  warningContainer: {
    flex: 1,
  },
  icon: {
    margin: 'auto',
    display: 'block',
    height: '15px',
  },
  message: {
    ...LEGACY_FONT_PROXIMA_13,
    display: 'inline-block',
  },
  messageContainer: {
    flex: 10,
    padding: '7px 0px',
  },
  button: {
    ':hover': {
      color: GRAY_DARKER,
      pointer: 'cursor',
    },
  },
});

export default WarningBanner;
